/**
 * 忘记密码页面
 */
// 必须引，否则没有css变量
import '@bfe/moly/dist/es/theme/cssVars/index.css';
// 必须引 否则组件没有样式
import '@bfe/moly/dist/es/theme/styles/tailwind.css';
// if you only need IBM fonts
import '@bfe/moly/dist/es/theme/font/font.css';
import './index.less';
import '@/utils/skynet';

import { message } from 'antd';
import React, { FC, lazy, Suspense, useEffect } from 'react';

import { useFingerPrint } from '@/hooks/useFingerPrint';
import useSecurityPreload from '@/hooks/useSecurityPreload';
import { I18nProvider } from '@/i18n/I18n';
import { DeadPoolProvider } from '@/store/useDeadPool';
import { UserProvider, useUserStore } from '@/store/useUser';
import { demoAccountAllowPath } from '@/utils/constants/common';
import { reactRTLJsInit, rtlAdapter } from '@/utils/rtl';
import { isMobile } from '@/utils/ua';

import Entry from './Entry';

const UniframeHeaderFooter = lazy(
  () => import('@/components/UniframeHeaderFooter'),
);

const AppAdapter = lazy(() => import('@/components/AppAdapter'));

reactRTLJsInit(React);

const Retrieve: FC = () => {
  const { fingerReport } = useFingerPrint();
  const {
    loading: userInfoLoading,
    accountIdentity,
    userProfile,
  } = useUserStore();

  useEffect(() => {
    rtlAdapter();

    if (isMobile()) {
      const el = document.createElement('meta');
      el.setAttribute('name', 'viewport');
      el.setAttribute(
        'content',
        'width=device-width,initial-scale=0.85,user-scalable=no',
      );
      document.head.append(el);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (
        !userInfoLoading &&
        accountIdentity.includes('demo_account') &&
        !demoAccountAllowPath.includes(path)
      ) {
        message.info({
          content: 'Demo accounts cannot access this page',
          onClose() {
            window.location.href = window.location.origin;
          },
        });
      }
    }
  }, [accountIdentity, userInfoLoading]);

  useSecurityPreload();

  useEffect(() => {
    fingerReport('wf04', '2');
  }, []);

  return (
    <>
      <Suspense>
        <UniframeHeaderFooter userInfo={userProfile} />
        <AppAdapter />
      </Suspense>
      <Entry />
    </>
  );
};

const RetrieveWrap = () => {
  return (
    <I18nProvider>
      <UserProvider>
        <DeadPoolProvider>
          <Retrieve />
        </DeadPoolProvider>
      </UserProvider>
    </I18nProvider>
  );
};

export default RetrieveWrap;
